import type { TFunction } from 'i18next';
import { AuthorizationApiError } from '~/app/services/authorization/authorization-api-error';

export function resolveAuthorizationErrorMessage(
  error: unknown,
  t: TFunction<'authorization'>,
  fallbackKey: string,
): string {
  if (error instanceof AuthorizationApiError && error.reason) {
    return t(`errors.${error.reason}`, {
      defaultValue: error.message,
    });
  }

  if (error instanceof Error) {
    const message = error.message.trim();
    if (message.length > 0) {
      return message;
    }
  }

  return t(fallbackKey);
}
